import { useAtomValue } from 'jotai'
import useApprovalStatus from 'src/common/contracts/hooks/token/useApprovalStatus'
import useVicc from 'src/common/queries/useVicc'
import { AnyToken } from 'src/common/types/models/Tokens'
import useConfig from 'src/config/hooks/useConfig'
import { viccCountAtom } from '../../bundle-store'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'

const useCarbonApproval = () => {
  const { contractsAddresses } = useConfig()
  const { smartAccountInfo } = useSmartAccount()

  const { vicc, isLoading: viccLoading } = useVicc()

  const viccCount = useAtomValue(viccCountAtom)

  const viccApproval = useApprovalStatus({
    owner: smartAccountInfo?.address,
    spender: contractsAddresses.carbonBundleAddress,
    amountToSpend: 1,
    token: vicc as AnyToken,
  })

  const needsApproval = viccCount > 0 && viccApproval.needsApproval

  const refetchAllowance = viccApproval.refetchAllowance

  const loading = (viccCount > 0 && viccApproval.loading) || viccLoading

  return {
    needsApproval,
    refetchAllowance,
    loading,
    approveVicc: viccApproval.approveTokenTx,
  }
}

export default useCarbonApproval
